import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowDownShortWide,
    faArrowsRotate,
    faBoxArchive,
    faCaretLeft,
    faCaretRight,
    faCheck,
    faCheckCircle,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleInfo,
    faClock,
    faDownload,
    faEdit,
    faExclamationTriangle,
    faFlag,
    faFolder,
    faGlobe,
    faInfoCircle,
    faList,
    faLock,
    faMouse,
    faPaperclip,
    faPenToSquare,
    faPlus,
    faPlusCircle,
    faPrint,
    faQuestion,
    faSearch,
    faSortDown,
    faSortUp,
    faTimes,
    faTimesCircle,
    faTrash,
    faTruckFast,
    faUnlock,
    faXmark,
    faEye,
    faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

export const fas = {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowDownShortWide,
    faArrowsRotate,
    faBoxArchive,
    faCaretLeft,
    faCaretRight,
    faCheck,
    faCheckCircle,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleInfo,
    faClock,
    faDownload,
    faEdit,
    faExclamationTriangle,
    faFlag,
    faFolder,
    faGlobe,
    faInfoCircle,
    faList,
    faLock,
    faMouse,
    faPaperclip,
    faPenToSquare,
    faPlus,
    faPlusCircle,
    faPrint,
    faQuestion,
    faSearch,
    faSortDown,
    faSortUp,
    faTimes,
    faTimesCircle,
    faTrash,
    faTruckFast,
    faUnlock,
    faXmark,
    faEye,
    faEyeSlash,
};
